import TelIcon from 'components/elements/icons/TelIcon'
import Text from 'components/elements/texts/Text'
import React from 'react'
import styled from 'styled-components'

/**
 * 電話+ヘルプ文字付きアイコン
 */
const WrappedTelIcon: React.FC = () => {
  return (
    <TelIconWrapper>
      <StyledTelIcon width="18px" height="18px" color="var(--color-main)" />
      <IconLabel>ヘルプ</IconLabel>
    </TelIconWrapper>
  )
}

const TelIconWrapper = styled.div`
  box-sizing: border-box;
  width: 44px;
  height: 44px;
  text-align: center;
  background: var(--color-text-for-main-background);
  border: 2px solid var(--color-main);
  border-radius: 50%;
`

const StyledTelIcon = styled(TelIcon)`
  position: relative;
  top: 7px;
  display: block;
  line-height: 18px;
`

const IconLabel = styled(Text)`
  position: relative;
  top: 4px;
  color: var(--color-main);
  font-weight: bold;
  font-size: 8px;
`

export default WrappedTelIcon
